export const DEFAULT_EXPECT_TOKEN_TIMEOUT_SECONDS = 120; // 2 minutes

export const DEFAULT_MAX_CLIENT_SENDS_RETRIES = 3;
